import * as PIXI from 'pixi.js';

window.PIXI = PIXI;

export class PixiBase {
  constructor() {
    this.P = PIXI;
  }

  static PIXI = null;

  static Spine = null;

  static _observers = [];

  static createApplication(config = {}) {
    const app = new PixiBase.PIXI.Application({ ...config });
    window.__PIXI_APP__ = app;
    return app;
  }

  static createContainer(name) {
    const container = new PixiBase.PIXI.Container();
    if (name) {
      container.name = name;
    }
    return container;
  }

  static createBlurFilter() {
    return new PixiBase.PIXI.BlurFilter();
  }

  static setMaskGraphicToContainer(container, mask) {
    container.mask = mask;
    return container;
  }

  static createSpine() {
    return new this.P.spine.Spine(source.spineData);
  }

  static setAnimation(texture, name, loop = false) {
    return new Promise((resolve) => {
      texture.state.clearTracks();
      texture.state.addAnimation(0, name, loop);
      texture.state.addListener({
        complete: function () {
          resolve(texture);
        },
      });
    });
  }

  static clearTrack(texture) {
    texture.state.clearTracks();
  }

  static addChildToSlot(slotName, child, index = 0) {
    const slot = PixiBase.getSlot(slotName);
    if (slot) {
      (slot.children[index] || slot).addChild(child);
      return true;
    }
    return false;
  }

  static getSlot({ texture, name }) {
    const index = texture.spineData.slots.findIndex((slotData) => slotData.name === name);
    return texture.children[index].children[0];
  }

  static createSprite(texture) {
    return new PixiBase.PIXI.Sprite(texture);
  }

  static createLoader() {
    return PixiBase.PIXI.Assets;
  }

  static changeFrame(sprite, frameName) {
    sprite.texture = PixiBase.PIXI.Texture.from(frameName);
  }

  static setPosition(element, { x = 0, y = 0 } = {}) {
    element.x = x;
    element.y = y;
  }

  static setSizes(element, { w = 0, h = 0 }) {
    element.width = w;
    element.height = h;
  }

  static setPivot(element, { x, y }) {
    element.x = x;
    element.y = y;
  }

  static createText(text, style) {
    return new PixiBase.PIXI.Text(text, style);
  }

  static createGraphics() {
    return new PixiBase.PIXI.Graphics();
  }

  static setMaskGraphicProperties(graphic, config) {
    graphic.beginFill('red');
    graphic.drawRect(...config);
    graphic.endFill();
    return graphic;
  }

  static addSubscriber(obs) {
    PixiBase._observers.push(obs);
    return obs;
  }

  static destroy() {
    PixiBase._observers.forEach((obs) => {
      obs.unsubscribe();
    });
    PixiBase._observers = [];
  }

  static calculatePosition({ element, containerName, position = { x: 0, y: 0 } }) {
    if (!element.parent) {
      return position;
    }

    if (element.parent.name === containerName) {
      return position;
    }

    const newPosition = {
      x: position.x + element.parent.position.x,
      y: position.y + element.parent.position.y,
    };

    return this.calculatePosition({
      element: element.parent,
      containerName,
      position: newPosition,
    });
  }

  static setupButtonMode(texture, { interactive = true, buttonMode = true } = {}) {
    texture.interactive = interactive;
    texture.buttonMode = buttonMode;
    if (buttonMode) {
      texture.cursor = 'pointer';
    }
  }

  static registerClick(texture, onClick) {
    return texture.on('pointerdown', onClick);
  }

  static registerPointerover(texture, event) {
    return texture.on('pointerover', event);
  }

  static registerPointerout(texture, event) {
    return texture.on('pointerout', event);
  }

  static registerPointerup(texture, event) {
    return texture.on('pointerup', event);
  }

  static registerPointerMove(texture, event) {
    return texture.on('pointermove', event);
  }

  static registerPointerUpOutside(texture, event) {
    return texture.on('pointerupoutside', event);
  }
}
